var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoddefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21225 3.00386L1.28362 11.6289C1.10794 11.9363 1.10794 12.3137 1.28362 12.6211L6.21225 21.2461C6.3903 21.5577 6.72164 21.75 7.08049 21.75H16.9198C17.2787 21.75 17.61 21.5577 17.788 21.2461L22.7166 12.6211C22.8923 12.3137 22.8923 11.9363 22.7166 11.6289L17.788 3.00386C17.61 2.69229 17.2787 2.5 16.9198 2.5H7.08049C6.72164 2.5 6.3903 2.69228 6.21225 3.00386ZM7.19909 20.5421L2.38926 12.125L7.19909 3.70792H16.8012L21.6109 12.125L16.8012 20.5421H7.19909Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoddefault);
export default __webpack_public_path__ + "static/media/Pod default.e3da914dca08512513732d46a17a210e.svg";
export { ForwardRef as ReactComponent };